import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

const Sticky = ({ children, offSetY, className, isSticky, setStickyFromProps }) => {
  const [sticky, setSticky] = useState()

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleScroll = () => {
    const scrollPosition = window.scrollY

    scrollPosition > offSetY ? setSticky(true) : setSticky(false)
    isSticky !== undefined && scrollPosition > offSetY
      ? setStickyFromProps(true)
      : setStickyFromProps(false)
  }

  // doppio children, il secondo visibile solo quando c'è lo sticky
  // per mantenere l'ingombro nel punto iniziale altrimenti cambia height della window e ci degli scroll automatici strani
  return (
    <div>
      <div
        className={
          'sticky' +
          (isSticky ? ' sticky--active' : '') +
          (className ? ' ' + className : '') +
          (isSticky && className ? ' ' + className + '--sticky' : '')
        }
      >
        {children}
      </div>
      {isSticky && <div className="sticky--inactive">{children}</div>}
    </div>
  )
}

export default React.memo(Sticky)
